module.exports = __webpack_public_path__ + "assets/img/eternia-solar-logo-small.8894baf2.webp";